/*@ngInject*/
const UIAutoFocusDirective = function () {
    return {
        link: {
            pre: function preLink(scope, element, attr) {
                // this fails since the element hasn't rendered
            },
            post: function postLink(scope, element, attr) {
                // this succeeds since the element has been rendered
                if (attr.uiAutoFocus === 'true') {
                    element[0].focus();
                }
            }
        }
    };
};

angular.module('umCore')
    .directive('uiAutoFocus', UIAutoFocusDirective);
